import {
  Box,
  Grid,
  Paper,
  useMediaQuery
} from '@mui/material'
import './ephTracker.css'
import TrackerFilter from './trackerFilter'
import { useEffect, useRef, useState } from 'react'
import RequestList from './requestList'
import RequestDetails from './requestDetails'
import Profile from '../raise-access/profile'
import { useTheme } from '@emotion/react'
import ProgressBar from '../progress/progressBar'
import SnackBar from './snackbar'

const EphTracker = props => {
  // code for setting intial setSearchedData for DCR and Merge as last 7 days
  let todayDate = new Date()
  let endDate = todayDate.getFullYear() + '-' + (todayDate.getMonth() < 9 ? '0' + (todayDate.getMonth() + 1) : (todayDate.getMonth() + 1)) + '-' + (todayDate.getDate() < 10 ? '0' + todayDate.getDate() : todayDate.getDate())
  let startDate = new Date(todayDate.getTime() - (7 * 24 * 60 * 60 * 1000))
  startDate = startDate.getFullYear() + '-' + (startDate.getMonth() < 9 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
  const [searchedData, setSearchedData] = useState({ DCR: {timeInterval: "Last 7 Days", startDate: startDate, endDate: endDate}, Merge: {timeInterval: "Last 7 Days", startDate: startDate, endDate: endDate} })

  // const [searchedData, setSearchedData] = useState({ DCR: {}, Merge: {} })
  const [openAdvanceSearch, setOpenAdvanceSearch] = useState(true)
  const [getSelectedRequestDetails, setGetSelectedRequestDetails] = useState([])
  const [openDetails, setOpenDetails] = useState(false)
  const [currentTab, setCurrentTab] = useState({
    DCR: 'All',
    Merge: 'All'
  })
  const [selectedTab, setSelectedTab] = useState('DCR')
  const [cardHeight, setCardHeight] = useState(0)
  const childRef = useRef()
  const advanceSearchApiCall = useRef()
  const [loading, setLoading]= useState(false)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [snackMessage, setSnackMessage] = useState({'type': '', 'message':''})
  const [focusedFormButton, setFocusedFormButton] = useState(false)

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false)
  };

  const handleSearch = (searchedData) => {
    setSearchedData(searchedData)
    if (advanceSearchApiCall.current) {
      advanceSearchApiCall.current.handleRequest(searchedData, null, true)
    }
  }

  // code for focusing on the select element in advance search
  const selectRef = useRef(null)
  const focusSelect = () => {
    if (selectRef.current) {
      // focus on the select element
      setOpenAdvanceSearch(true)
      selectRef.current.focus()
      setFocusedFormButton(true)
    }
  }

  const handleManualFocus = () => {
    setFocusedFormButton(false)
  }

  const handleTabChange = (tab)=>{
    if(selectedTab != tab){
      setSelectedTab(tab)
    }    
  }

  const handleFilterData = (searchedData) =>{
    setSearchedData(searchedData)
  }

  const getCurrentTab = (tab) =>{
    setCurrentTab({...currentTab, [selectedTab]: tab})
  }

  const refreshTab = (searchedData) => {
    setSearchedData(searchedData)
    if(currentTab[selectedTab] == 'All'){
      if (advanceSearchApiCall.current) {
        advanceSearchApiCall.current.handleRequest(searchedData)
      }
    }
    else if(currentTab[selectedTab] == 'MyAssignment'){
      if (advanceSearchApiCall.current) {
        advanceSearchApiCall.current.myAssignedRequest(searchedData)
      }
    }    
  }

  const ClearAdvanceSearch = () => {
    if (childRef.current) {
      childRef.current.clearAll()    
    }   
  }

  const handleFilter = () => {
    setOpenAdvanceSearch(!openAdvanceSearch)
  }
  const getDetails = data => {
    setGetSelectedRequestDetails(data)
    setOpenAdvanceSearch(false)
    setOpenDetails(true)
  }

  const closeDetails = () => {
    setOpenDetails(false)
    advanceSearchApiCall.current.closeDetails(false)
  }

  const cardRef = useRef(null)

  const getCardHeight = () => {
    if (cardRef.current) {
      const { height } = cardRef.current.getBoundingClientRect()
      setCardHeight(height)
    }
  }

  useEffect(()=>{
    getCardHeight();
    window.addEventListener("resize", getCardHeight)

    return()=>{
      window.removeEventListener('resize', getCardHeight)
    }
  },[])


  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (<>
     {loading && (
        <div className="extra-margin-top d-flex justify-content-center body-height">
          <ProgressBar />
        </div>
      )}
    {!loading && 
      props.user.isUserApprover?
      <div className={'container-fluid body-height extra-margin-top-less px-5'}>
        <Box container spacing={2} gap={2} display={'flex'} flexDirection={isMobile ? 'column' : 'row'}>
          <Grid
            sx={{ width: openAdvanceSearch ? isMobile ? '100%' : '25%' : '0px', display: isMobile && !openAdvanceSearch && 'none', transition: isMobile ? 'none' : 'width 0.3s ease', overflow: !openAdvanceSearch && 'hidden', minWidth: 0 }}
          >
              <Grid className='d-flex' style={{ flexDirection: 'column'}} sx={{ height:cardHeight , transform: isMobile ? 'none' : openAdvanceSearch ? 'translateX(0)' : 'translateX(-100%)', transition: isMobile ? 'none' : 'transform 0.3s ease'}}>
                <TrackerFilter
                  // onFilter={handleFilteredDcrData}
                  onQuery={(searchedData) => handleSearch(searchedData)}
                  ref={childRef}
                  searchedData={searchedData}
                  handleFilterData={(searchedData) => handleFilterData(searchedData)}
                  handleTabChange={(tab) => handleTabChange(tab)}
                  selectedTab={selectedTab}
                  setLoading={setLoading}
                  setOpenSnackBar={setOpenSnackBar}
                  setSnackMessage={setSnackMessage}
                  selectRef={selectRef}
                  highlight={focusedFormButton}
                  onUserInteraction={handleManualFocus}
                />
              </Grid>
            </Grid>

          <Grid
            sx={{ flexGrow: 1, transition: isMobile ? 'none' : 'all 0.3s ease' }}
          >
            <RequestList
              data={[]}
              query={searchedData}
              handleFilter={() => handleFilter()}
              openAdvanceSearch={openAdvanceSearch}
              setOpenAdvanceSearch = {setOpenAdvanceSearch}
              getDetails={data => getDetails(data)}
              ClearAdvanceSearch={() => ClearAdvanceSearch()}
              ref={advanceSearchApiCall}
              userId={props.user.user_id}
              currentTab={currentTab}
              getCurrentTab = {(tab)=> getCurrentTab(tab)}
              selectedTab = {selectedTab}
              cardRef={cardRef}
              openDetails = {openDetails}
              setOpenDetails = {setOpenDetails}
              selectedCard = {getSelectedRequestDetails}
              onFocusSelect={focusSelect}
            />
          </Grid>


              <Grid
                sx={{ width: !openAdvanceSearch && openDetails ? isMobile ? '100%' : '32%' : '0px', transition: isMobile ? 'none' : 'width 0.3s ease', overflow: !openDetails && 'hidden', minWidth: 0 }}
              >
                <Grid sx={{ transform: isMobile ? 'none' : !openAdvanceSearch && openDetails ? 'translateX(0)' : 'translateX(100%)', transition: isMobile ? 'none' : 'transform 0.3s ease' }}>
                  <Paper sx={{ height: cardHeight }} >
                    <RequestDetails
                      userId={props.user.user_id}
                      details={getSelectedRequestDetails}
                      closeDetails={() => closeDetails()}
                          refreshTab = {()=> refreshTab(searchedData)}
                          selectedTab = {selectedTab}
                    />
                  </Paper>
                </Grid>
              </Grid>
        </Box>
      </div>
        :<Profile noDcrAccess={true}/>}

        {openSnackBar && 
          <SnackBar 
            openSnackBar = {openSnackBar}
            handleCloseSnackBar ={()=> handleCloseSnackBar()}
            message = {snackMessage}
          />
        }
      </>
  )
}

export default EphTracker